import httpClient from "../httpClient";

const generatePDF = async (data) => {
  return await httpClient.post(
    `${process.env.REACT_APP_API_HOST.replace("/api/v1", "")}/pdf`,
    data
  );
};

export { generatePDF };
